import { isNull, isObject, isUndefined, mapValues } from "lodash-es";

const TRAILING_SLASH_REGEX = /\/+$/;

const dropTrailingSlashes = (str = ''): string =>
  str.replace(TRAILING_SLASH_REGEX, '');

const toSearchParams = (params: object): string => {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (isUndefined(value) || isNull(value)) {
      continue;
    }

    if (isObject(value)) {
      searchParams.append(key, JSON.stringify(value));
    } else {
      searchParams.append(key, value as string);
    }
  }

  return searchParams.toString();
};

const stringify = (pathname: string, params: object): string => {
  const query = toSearchParams(params);
  return toUrlPath(pathname, query);
};

const getSearchParams = (request: Request) => {
  const url = new URL(request.url);
  return Object.fromEntries(url.searchParams);
};

// Backend ids are not url safe. We have to encode them for time being.
const toEncodedIds = (ids: Record<string, unknown>): Record<string, string> =>
  mapValues(ids, (id) => encodeURIComponent(id as string));

const toUrlPath = (pathname: string, search = '') => {
  // TODO: Find a declarative way to construct path. using `URL` or something.
  const query = search.trim();
  if (!query) {
    return pathname;
  }
  const char = query.startsWith('?') ? '' : '?';
  return [pathname, query].join(char);
};

export {
  dropTrailingSlashes,
  getSearchParams, stringify, toEncodedIds,
  toUrlPath
};

